import AxiosClient from '../../../../functional/Axios/AxiosClient';

export const configApi = {
  getAppConfig: () => AxiosClient.get('/config'),

  getAdminAppConfig: () => AxiosClient.get('/root/config'),
};
